import Vue from "vue";
import Antd from "ant-design-vue";
import App from "./App";
import "ant-design-vue/dist/antd.css";
import "./fonts/font.css";
import "./utils/array_function";

// v gantt chart
import vGanttChart from "v-gantt-chart";
Vue.use(vGanttChart);

Vue.config.productionTip = false;
Vue.use(Antd);

// v-suggest
import vSuggest from "v-suggest";
Vue.use(vSuggest);

// v-print
import Print from "vue-print-nb";
Vue.use(Print); //注册

//editor
import wysiwyg from "vue-wysiwyg";
Vue.use(wysiwyg, {}); // config is optional. more below
import "vue-wysiwyg/dist/vueWysiwyg.css";

// excel
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

//routers and components
// vue router
import VueRouter from "vue-router";
Vue.use(VueRouter);

import capt_zhao_vsl_account from "./components/captxu/capt_zhao_vsl_account.vue";
import capt_zhao_transaction from "./components/captxu/capt_zhao_transaction.vue";


import vessel from "./components/vessel.vue";
import transactions from "./components/transactions.vue";
import map from "./components/map.vue";
import open from "./components/open.vue";
import ship_sync from "./components/ship_sync.vue";
import trade_profit from "./components/trade_profit.vue";

import pUSD from "./components/printUSD.vue";
import pRMB from "./components/printRMB.vue";
import records from "./components/records.vue";
import error from "./components/error.vue";

import payment_upload from "./components/payment_upload.vue";

// import cargo_vessel_pos from './components/cargo_vessel_pos.vue'
// import cargo_vessel_ops from './components/cargo_vessel_ops.vue'

import pwd from "./components/pwd.vue";
import voyage_pl from "./components/voyage_pl/voyage_pl.vue";
import documents_share from "./components/documents_share.vue";

const routes = [
  { path: "/capt_zhao_vsl_account/", component: capt_zhao_vsl_account },
  { path: "/capt_zhao_transaction/", component: capt_zhao_transaction },

  { path: "/vessel/", component: vessel },
  { path: "/transactions/:vid", component: transactions },
  { path: "/map/:id", component: map },
  { path: "/open/", component: open },
  { path: "/ship_sync/", component: ship_sync },
  { path: "/trade_profit/", component: trade_profit },

  { path: "/pUSD/:uid/:sq", component: pUSD },
  { path: "/pRMB/:uid/:sq", component: pRMB },
  { path: "/records", component: records },
  { path: "/error", component: error },

  { path: "/transaction2", component: payment_upload },

  // { path: '/cargo_vessel_pos', component: cargo_vessel_pos },
  // { path: '/cargo_vessel_ops', component: cargo_vessel_ops },
  { path: "/pwd", component: pwd },
  { path: "/voyage_pl", component: voyage_pl },
  { path: "/documents-share", component: documents_share },
];
const router = new VueRouter({
  //   mode: "hash",
  routes: routes,
});

// userinfo 和拦截器 和 global login mixins
import userinfo from "./utils/userinfo.js";
import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);
// Add access token to every request
Vue.axios.interceptors.request.use(function (config) {
  // return when fectch ship ID
  if (config.url.substr(7, 15) == "api.shipxy.com/") {
    return config;
  }
  if (userinfo.get()) {
    config.headers = Object.assign(config.headers, {
      access_token: userinfo.get().access_token,
    });
  }
  return config;
});
//
Vue.axios.interceptors.response.use(function (r) {
  // return when fectch ship ID
  if (r.config.url.substr(7, 15) == "api.shipxy.com/") {
    return r;
  }
  if (r.data.status !== 1) {
    vue_instance.$message.error(r.data.msg);
  }
  if (r.data.status == -1) {
    vue_instance.$isLogin = false;
    userinfo.remove();
    vue_instance.$router.push({ path: "/" }).catch(function () { });
  }
  return r;
});
// global login mixin
let globalData = new Vue({
  data: { $isLogin: false },
});
Vue.mixin({
  computed: {
    $isLogin: {
      get: function () {
        return globalData.$data.$isLogin;
      },
      set: function (val) {
        globalData.$data.$isLogin = val;
      },
    },
  },
});

import settings from "./vuex/settings.js";
import Capt_xu_vsl_mgt_cost from "./components/captxu/capt_zhao_vsl_account.vue";
const vue_instance = new Vue({
  render: (h) => h(App),
  router: router,
  store: settings,
}).$mount("#app");

//using global event to fix delete cards bugs
window.bus = new Vue({});
